import { render } from "./PontosLoraPub.vue?vue&type=template&id=56c172d0&scoped=true"
import script from "./PontosLoraPub.vue?vue&type=script&lang=js"
export * from "./PontosLoraPub.vue?vue&type=script&lang=js"

import "./PontosLoraPub.vue?vue&type=style&index=0&id=56c172d0&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-56c172d0"]])

export default __exports__